import { useMemo } from "react";
import {
  buildOperatorContextFromState,
  type OperatorContext,
} from "../modeling/operators.ts";
import { useStore } from "./store.ts";
import { useSelectedLeafObjectIds } from "./useSelectedLeafObjectIds.ts";

/**
 * React wrapper around the shared operator-context builder.
 *
 * UI surfaces should use this instead of rebuilding operator enablement
 * context ad hoc so menus, palettes, and search all stay in lockstep.
 */
export function useOperatorContext(): OperatorContext {
  const mode = useStore((s) => s.mode);
  const editMode = useStore((s) => s.editMode);
  const poseMode = useStore((s) => s.poseMode);
  const lockedBones = useStore((s) => s.lockedBones);
  const selectedObjectTargets = useStore((s) => s.selectedObjectTargets);
  const sceneObjects = useStore((s) => s.sceneObjects);
  const blendFiles = useStore((s) => s.blendFiles);
  const collections = useStore((s) => s.collections);
  const selectedLeafObjectIds = useSelectedLeafObjectIds();

  return useMemo(
    () =>
      buildOperatorContextFromState(
        {
          mode,
          editMode,
          poseMode,
          lockedBones,
          selectedObjectTargets,
          sceneObjects,
          blendFiles,
          collections,
        },
        selectedLeafObjectIds,
      ),
    [
      mode,
      editMode,
      poseMode,
      lockedBones,
      selectedObjectTargets,
      sceneObjects,
      blendFiles,
      collections,
      selectedLeafObjectIds,
    ],
  );
}
